import Vue from 'vue'
import { dateDot, ho, day, formatNumberFilter  } from '~/util/helpers/vueFilters'

Vue.filter('dateDot', dateDot)
// '2023-10-14 16:18:00' --> '14.10.2023'

Vue.filter('formatNumberFilter', formatNumberFilter)
///Добавлено для обратной совместимости с новой кассой(требует рефактора)///

Vue.filter('ho', ho)
// '10' --> '10 год'
// '10' --> '10 ч'

Vue.filter('day', day)
// '10' --> '10 д'
// '10' --> '10 д'
